import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/material'
import Button from '@mui/material/Button'

import { DialogWrapper } from '@/components'
import { useAppContext } from '@/hooks'
import { DependenciesModal } from '@/pages/User/pages/Home/components/Dependencies/components/DependenciesModal'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'

interface DependenciesBottomToolbarProps {
	editMode: boolean
	node: StructureDto
	refetch: () => void
}

export const DependenciesBottomToolbar = ({
	editMode,
	node,
	refetch,
}: DependenciesBottomToolbarProps) => {
	const { t } = useAppContext()
	return (
		<Box className="px-2 py-2">
			<DialogWrapper
				dialog={(opened, onClose) =>
					opened && (
						<DependenciesModal
							onClose={onClose}
							onSave={() => refetch()}
							node={node}
						/>
					)
				}
			>
				{(onClick) => (
					<Button
						size="large"
						onClick={onClick}
						variant="contained"
						disabled={!editMode}
					>
						<FontAwesomeIcon icon={faPlus} className="mr-2" />
						{t('ADD_NEW')}
					</Button>
				)}
			</DialogWrapper>
		</Box>
	)
}
